import { UseFormReturn } from 'react-hook-form'
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

interface AddressFormProps {
  form: UseFormReturn<any>
  prefix?: string // Para nested forms: 'client.address'
  required?: string[]
}

/**
 * Componente reutilizable para campos de dirección
 * Uso: <AddressForm form={form} />
 * Uso nested: <AddressForm form={form} prefix="client" />
 */
export function AddressForm({ form, prefix = '', required = [] }: AddressFormProps) {
  const getName = (field: string) => prefix ? `${prefix}.${field}` : field

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name={getName('adreca')}
        render={({ field }) => (
          <FormItem className="md:col-span-2">
            <FormLabel>
              Adreça {required.includes('adreca') && <span className="text-destructive">*</span>}
            </FormLabel>
            <FormControl>
              <Input {...field} placeholder="Carrer Principal, 123" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name={getName('ciutat')}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Ciutat {required.includes('ciutat') && <span className="text-destructive">*</span>}
            </FormLabel>
            <FormControl>
              <Input {...field} placeholder="Barcelona" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name={getName('codi_postal')}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Codi Postal {required.includes('codi_postal') && <span className="text-destructive">*</span>}
            </FormLabel>
            <FormControl>
              <Input {...field} placeholder="08001" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name={getName('provincia')}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Província {required.includes('provincia') && <span className="text-destructive">*</span>}
            </FormLabel>
            <FormControl>
              <Input {...field} placeholder="Barcelona" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name={getName('pais')}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              País {required.includes('pais') && <span className="text-destructive">*</span>}
            </FormLabel>
            <FormControl>
              <Input {...field} placeholder="Espanya" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
